import { createRouter, createWebHistory } from 'vue-router'
import PageView from '../views/PageView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  /**
   * PWA / SPA: new navigations start at the top; back/forward restores browser position.
   * In-page anchors (same or other route with `hash`) still scroll to the target element.
   */
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash, top: 96, behavior: 'smooth' }
    }
    return { top: 0, left: 0 }
  },
  routes: [
    {
      path: '/certificate/verify/:token',
      name: 'certificate-verify',
      component: () => import('../views/CertificateVerifyView.vue'),
    },
    {
      path: '/block-preview/:blockKey',
      name: 'block-preview',
      meta: { blockPreview: true },
      component: () => import('../views/BlockPreviewView.vue'),
    },
    {
      path: '/account/verify-email',
      name: 'verify-email',
      component: () => import('../views/VerifyEmailView.vue'),
    },
    {
      path: '/account/password/reset',
      name: 'password-reset-request',
      component: () => import('../views/PasswordResetRequestView.vue'),
    },
    {
      path: '/account/password/reset/key/:key',
      name: 'password-reset-confirm',
      component: () => import('../views/PasswordResetConfirmView.vue'),
    },
    /** Sign-in / sign-up tabs (unauthenticated); distinct from dashboard `/account/passkeys`. */
    {
      path: '/account/link',
      name: 'account-login-link',
      component: () => import('../views/AccountView.vue'),
    },
    {
      path: '/account/passkey',
      name: 'account-login-passkey',
      component: () => import('../views/AccountView.vue'),
    },
    {
      path: '/account/signup',
      name: 'account-signup',
      component: () => import('../views/AccountView.vue'),
    },
    /**
     * Dashboard sections: `/account/submissions` (my applications), password, passkeys;
     * `/account/details` is canonical `/account`.
     * Use `submissions` not `workflows` so `/account/workflows` can stay a Wagtail page path.
     */
    {
      path: '/account/:section(details|password|passkeys|submissions)',
      name: 'account-tab',
      component: () => import('../views/AccountView.vue'),
    },
    {
      path: '/account',
      name: 'account',
      component: () => import('../views/AccountView.vue'),
    },
    {
      path: '/help-query/status',
      name: 'help-query-status',
      component: () => import('../views/HelpQueryStatusView.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'page',
      component: PageView,
    },
  ],
})

// Normalize encoded pathnames to decoded so back/forward and history stay consistent
// (browser can store encoded URLs; we always use decoded for matching and links)
router.beforeEach((to) => {
  try {
    const decodedPath = decodeURI(to.path)
    if (decodedPath !== to.path) {
      return { path: decodedPath, query: to.query, hash: to.hash, replace: true }
    }
  } catch {
    // leave path unchanged if decodeURI throws
  }
})

export default router
